import axios from 'axios';
import { getToken, clearToken } from '@/lib/tokenStore';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// 15s timeout on all API calls. Prevents iOS Safari (and other browsers)
// from hanging forever if the server never responds — instead we surface a
// clear error the caller can show to the user.
const api = axios.create({ baseURL: API, timeout: 15000 });

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Single-device session enforcement: on 401 (session invalidated by newer login),
// silently clear local token and redirect to login. No toast, no warning.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Normalise timeout/network errors so callers can distinguish "no reply"
    // from a genuine 4xx/5xx.
    if (err?.code === 'ECONNABORTED' || /timeout/i.test(err?.message || '')) {
      err.isTimeout = true;
      err.friendlyMessage = 'Serveren svarer ikke — tjek din internetforbindelse og prøv igen.';
    } else if (!err?.response) {
      err.isNetworkError = true;
      err.friendlyMessage = 'Kunne ikke kontakte serveren — tjek din internetforbindelse.';
    }
    if (err?.response?.status === 401) {
      const wasLoggedIn = !!getToken();
      clearToken();
      if (wasLoggedIn && !window.location.pathname.startsWith('/login')) {
        window.location.replace('/login');
      }
    }
    return Promise.reject(err);
  },
);

export default api;
